import React from 'react'
import popup from "~/views/Popup/popup"
import StripeIDeal from '~/components/StripeiDealForm'
import StripeIDealTVOD from '~/components/StripeiDealForm/iDealTVOD'
import Spinner from '~/components/Spinner'
import './style.scss'

class ideal extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: true,
      purchase: props.args.purchase
    }
  }

  handleClose() {
    popup.hide()
  }

  componentDidMount() {
    this.setState({loading: false})
  }

  render() {
    if (this.state.loading)
      return (<div className="loading centered"><Spinner/></div>)
    
      return (
        <div>
          {!this.props.args.purchase && <StripeIDeal 
            plan={this.props.args.metadata.plan}
            offerCode = {this.props.args.metadata.offerCode}
            amount={this.props.args.metadata.firstPayment && this.props.args.metadata.firstPayment.amount.toFixed(2)}
            fields={this.props.args.metadata.metadataMap}
          />}
          {this.props.args.purchase  && <StripeIDealTVOD 
            contentId={this.props.args.metadata.content && this.props.args.metadata.content.gist && this.props.args.metadata.content.gist.id}
            contentType={this.props.args.metadata.contentType}
            plan={this.props.args.metadata.plan}
            amount={this.props.args.metadata.firstPayment && this.props.args.metadata.firstPayment.amount.toFixed(2)}
            offerCode = {this.props.args.metadata.offerCode}
            fields={this.props.args.metadata.metadataMap}
          />}
        </div>    
      )
  }
   
}


export default ideal;